/*eslint sort-imports:0*/

import PackagesUtil from 'santa-main-r/lib/lib/common/PackagesUtil.js'
import addExperimentsFromQuery from 'santa-main-r/lib/lib/common/addExperimentsFromQuery.js'
import {getBaseVersion} from 'santa-main-r/lib/lib/common/getBaseVersion'
import experimentFactory from 'santa-main-r/lib/lib/common/experimentFactory.js'
import getFullRjsConfig from 'santa-main-r/lib/lib/common/getFullRjsConfig.js'
import getQueryUtils from 'santa-main-r/lib/lib/common/getQueryUtils.js'
import getSubdomain from 'santa-main-r/lib/lib/common/getSubdomain.js'
import identifyForFullStory from 'santa-main-r/lib/lib/editor/identifyForFullStory.js'
import instrument from 'santa-main-r/lib/lib/editor/instrument.js'
import isLocal from 'santa-main-r/lib/lib/common/isLocal.js'
import createLogger from 'santa-main-r/lib/lib/common/logger.js'
import joinURL from 'santa-main-r/lib/lib/common/joinURL.js'
import overrideScriptsLocationMapFromQuery from 'santa-main-r/lib/lib/common/overrideScriptsLocationMapFromQuery.js'
import requirejs from 'requirejs'
import rjsConfig from 'santa-main-r/lib/lib/editor/rjs-config.js'
import runEditor from './runEditor.js'
import storageUtil from 'santa-main-r/lib/lib/common/storageUtil.js'

const {versions} = require('../../../gen/options.json')
const packages = require('../../../gen/packagesList.json')
const packagesJson = require('../../../package.json')

const queryUtil = getQueryUtils(window)

window.define('experiment', [], () => experimentFactory.build(window))

window.joinURL = joinURL
window.queryUtil = queryUtil
window.persistent = storageUtil(window) // TODO: how is this used?
window.identifyForFullStory = identifyForFullStory

if (window.customRenderSite !== undefined) { // allows to override this in other html files as starting points
    window.customRenderSite()
}

function applyTopologyOverriding() {
    const versionRegExp = /1.*\d.\d/g
    window.serviceTopology.scriptsLocationMap['santa-langs'] = window.serviceTopology.scriptsLocationMap['santa-langs'].replace(versionRegExp, packagesJson.peerDependencies['santa-langs'])
    window.serviceTopology.scriptsLocationMap = overrideScriptsLocationMapFromQuery(window.serviceTopology.scriptsLocationMap, queryUtil.getParameterByName('scriptsLocations'))
}

export function start(shouldRender = true, measureFrameRate = true) {
    const local = isLocal(queryUtil.getParameterByName('EditorSource'))
    const {loggerModel, Sentry, editorModel} = window

    const getEditorRjsConfig = rjsConfig(window, versions, local)
    const packagesUtil = new PackagesUtil(packages, window.location.search)

    if (editorModel) {
        editorModel.runningExperiments = addExperimentsFromQuery(editorModel.runningExperiments, queryUtil, 'editor')
        editorModel.languageCode = queryUtil.getParameterByName('lang') || editorModel.languageCode
    }

    applyTopologyOverriding()

    const config = getFullRjsConfig(
        'santa-editor',
        window.editorBase,
        getEditorRjsConfig(
            window.serviceTopology,
            editorModel,
            window.santaBase,
            PackagesUtil
        ),
        packagesUtil,
        window.serviceTopology
    )

    if (editorModel) {
        editorModel.editorBase = config.baseUrl
        editorModel.editorVersion = getBaseVersion(config.baseUrl)
    }

    const logger = createLogger({local, loggerModel, editorModel}, Sentry)
    window.initiatedSentry = logger

    window.mainLoaded = Date.now()

    if (editorModel) {
        instrument(window, requirejs, queryUtil, logger, editorModel)

        const performance = window.performance
        const navigation = performance ? performance.navigation : undefined
        const navigationType = navigation ? navigation.type : undefined
        //newer implementation window.performance.getEntriesByType("navigation")[0].type;

        //MAIN_R_LOADED evt
        window.bi.event(458, { // main-r loaded event
            prefetch: window.afterEditorPrefetch,
            esi: window.editorModel.editorSessionId,
            msid: window.editorModel.metaSiteId,
            navigationType
        })
    } else {
        instrument(window, requirejs, queryUtil, logger)
    }

    requirejs.config(config)

    try {
        window.document.domain = getSubdomain(window.document.domain)
    } catch (e) {
        // empty
    }

    if (isLocal(window.editorBase) && queryUtil.getParameterByName('hot') !== 'false') {
        return new Promise(resolve => {
            requirejs([
                'hot',
                'zepto'
            ], (
                hot,
                $
            ) => {
                hot.init($, false)
                resolve(runEditor(window, packages, requirejs, editorModel, queryUtil, config, shouldRender, measureFrameRate, logger))
            })
        })
    }
    return runEditor(window, packages, requirejs, editorModel, queryUtil, config, shouldRender, measureFrameRate, logger)
}
